import { render, staticRenderFns } from "./tabFanExperience.vue?vue&type=template&id=283a03d9&"
import script from "./tabFanExperience.vue?vue&type=script&lang=js&"
export * from "./tabFanExperience.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports